const toastStyles = {
  toastText: {
    fontWeight: 400,
  },
};

export default toastStyles;
